<template>
  <el-dialog
    :visible="visible"
    :title="title"
    :width="fullscreen ? '95%' : '50%'"
    :top="fullscreen ? '5vh' : '15vh'"
    :custom-class="customClass || 'responsive-dialog'"
    append-to-body
    :close-on-click-modal="false"
    lock-scroll
    center
    :close-icon="'el-icon-close'"
    @update:visible="$emit('update:visible', $event)"
  >
    <template #title>
      <slot name="title">{{ title }}</slot>
    </template>

    <div
      :class="[
    'dialog-scroll-wrapper',
    'd-flex flex-column align-items-center',
    { 'quiz-ai': quizAi },
  ]"
      :style="scrollWrapperStyle"
    >
      <slot />
    </div>

    <template v-if="showFooter" #footer>
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "AIVDialog",
  model: { prop: "visible", event: "update:visible" },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, default: "" },
    quizAi: { type: Boolean, default: false },
    showFooter: { type: Boolean, default: true },
    customClass: { type: String, default: "" },
    fullscreen: { type: Boolean, default: false }, // ✅ added
  },
  computed: {
    scrollWrapperStyle() {
      if (this.fullscreen) {
        return {
          maxHeight: "80vh", // match fullscreen modal height
          width: "95%",
        };
      }
      return {
        maxHeight: "calc(100vh - 380px)",
        width: "75%",
      };
    },
  },
};
</script>


<style>
.dialog-scroll-wrapper {
  max-height: calc(100vh - 380px);
  overflow-y: auto;
  padding-right: 1rem;
  width: 75%;
}
.dialog-scroll-wrapper.quiz-ai {
  width: 100%;
  overflow-y: hidden;
  height: 68vh;
  max-height: 68vh;
  margin: 0 0 0 15px;
}

.el-dialog {
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.el-dialog__body,
.el-dialog__footer {
  background-color: white;
  color: black;
  border: none;
  box-shadow: none;
  width: 100%;
  padding: 15px 0 !important;
}

.el-dialog__header {
  color: black;
  flex: 1;
  text-align: center;
}

.el-dialog__footer,
.el-dialog__body {
  display: flex !important;
  justify-content: center;
}

.el-dialog__wrapper {
  background-color: transparent;
}

/* Modal close button styling */
.el-dialog__headerbtn {
  top: 15px !important;
  right: 15px !important;
  padding: 0 !important;
  background: none !important;
  border: none !important;
  outline: none !important;
  width: auto !important;
  height: auto !important;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #000000 !important;
  font-size: 18px !important;
  background: none !important;
  border: none !important;
  outline: none !important;
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
  text-align: center !important;
}

.el-dialog__headerbtn .el-dialog__close:hover {
  color: #666666 !important;
  background: none !important;
  border: none !important;
}

.el-dialog__headerbtn .el-dialog__close:focus {
  background: none !important;
  border: none !important;
  outline: none !important;
}

/* Ensure el-icon displays properly */
.el-dialog__headerbtn .el-dialog__close.el-icon-close:before {
  content: "\e6db" !important;
  font-family: "element-icons" !important;
}

/* override Element's inline width on small screens */
@media (max-width: 768px) {
  .responsive-dialog {
    width: 90% !important;
    margin: 0 auto;        /* center it horizontally */
  }
}
</style>

